export default __webpack_public_path__ + "static/media/bg-sign_up.86b0098e.png";